module.exports = __webpack_public_path__ + "static/img/chart3.aed9397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart3.png
// module id = HUfC
// module chunks = 1